export default __webpack_public_path__ + "static/media/clp.dc3ccb41.mp3";